import { PriceResultGroupDetail } from "@/lib/type";

const CarDetailTile: React.FC<PriceResultGroupDetail> = ( group_detail ) => {
  return (
    <div className="grid grid-cols-6 gap-x-2 font-bold">
      <div className="flex flex-row space-x-1">
        <img src="/icon/passenger.svg" />
        <span>{group_detail.seats}</span>
      </div>
      <div className="flex flex-row space-x-1">
        <img src="/icon/gate.svg" />
        <span>{group_detail.doors}</span>
      </div>
      <div className="flex flex-row space-x-1">
        <img src="/icon/luggage.svg" />
        <span>{group_detail.suitcases}</span>
      </div>
      <div className="flex flex-row space-x-1">
        <img src="/icon/type.svg" />
        <span>{group_detail.is_automatic ? "A" : "M"}</span>
      </div>
      <div className="flex flex-row space-x-1">
        <img src="/icon/fan.svg" />
        <span>A/C</span>
      </div>
      <div className="flex flex-row space-x-1">
        <img src="/icon/age.svg" />
        <span>{group_detail.min_age}</span>
      </div>
    </div>
  );
};

export default CarDetailTile;
